import slugify from 'slugify';
import nl2br from 'nl2br';

export default {

    TRUNCATE_MAX_LENGTH: 140,

    identifier(str, prefix = '') {
        if (!str) return null;
        str = str.replace(/\(.*?\)/g, '').trim();
        const regex = /^[A-Za-z]/;
        if (str && regex.test(str)) {
            return slugify(`${prefix}${str}`, {
                lower: true,
            });
        }
        return null;
    },

    formatHtml(html) {
        if (!html) return null;

        const trimmed = html.trim();
        if (!/<(?:p|br)\b/i.test(trimmed)) {
            return nl2br(trimmed);
        }

        return trimmed;
    },

    plainText(value) {
        if (value === undefined || value === null || value === '') return '';

        const doc = new DOMParser().parseFromString(String(value), 'text/html');

        return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    },

    isEmptyParagraph(node) {
        return node.tagName === 'P' && node.querySelector('br') && !node.textContent.trim();
    },

    textLength(html) {
        if (!html) return 0;

        const temp = document.createElement('div');
        temp.innerHTML = html;

        return temp.textContent.length;
    },

    canExpand(html, maxLength = this.TRUNCATE_MAX_LENGTH) {
        return this.textLength(html) > maxLength;
    },

    truncateHtml(html, maxLength = this.TRUNCATE_MAX_LENGTH) {
        if (!html) return null;

        const temp = document.createElement('div');
        temp.innerHTML = html;

        let charCount = 0;
        let truncated = false;

        const walk = (parent) => {
            for (const child of Array.from(parent.childNodes)) {
                if (truncated) {
                    child.remove();
                    continue;
                }
                if (child.nodeType === Node.TEXT_NODE) {
                    const remaining = maxLength - charCount;
                    if (child.textContent.length > remaining) {
                        child.textContent = child.textContent.slice(0, remaining).replace(/\s+$/, '');
                        const ellipsis = document.createElement('span');
                        ellipsis.className = 'truncate-ellipsis';
                        ellipsis.textContent = ' ...';
                        child.parentNode.insertBefore(ellipsis, child.nextSibling);
                        charCount = maxLength;
                        truncated = true;
                    } else {
                        charCount += child.textContent.length;
                    }
                } else if (child.nodeType === Node.ELEMENT_NODE) {
                    walk(child);
                    if (!child.textContent.length && child.tagName !== 'BR' && !this.isEmptyParagraph(child)) {
                        child.remove();
                    }
                }
            }
        };
        walk(temp);

        return temp.innerHTML.trim();
    },

}
